import { Injectable } from "@angular/core";
import { ResponseCommonSI } from "@interfaces/services/common.interfaces";
import { firstValueFrom } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { BASE_URL, ENDPOINTS } from "@core/config/constants";
import { ConfirmSI, DetailCompanySI, ProjectDetailCompany } from "@views/interfaces/services/confirm";

@Injectable({
  providedIn: "root",
})
export class ConfirmService {

  constructor(
    private http: HttpClient
  ) { }

  async getDetailCompany(): Promise<DetailCompanySI> {
    const result = await firstValueFrom<ResponseCommonSI<DetailCompanySI>>(this.http.get(`${BASE_URL}${ENDPOINTS.DETAIL_COMPANY}`));
    return result.payload;
  }

  async getDetailProject(idProject: string): Promise<ProjectDetailCompany> {
    const result = await firstValueFrom<ResponseCommonSI<ProjectDetailCompany>>(this.http.get(`${BASE_URL}${ENDPOINTS.DETAIL_PROJECT.replace(':idProject', idProject)}`));
    return result.payload;
  }

  async confirm(body): Promise<ConfirmSI> {
    const result = await firstValueFrom<ResponseCommonSI<ConfirmSI>>(this.http.post(`${BASE_URL}${ENDPOINTS.CONFIRM}`, body));
    return result.payload;
  }
}
